export enum AnnonceCategory {
  TeacherJobOffer = 'teacher',
  AdministrativeJobOffer = 'secretary',
  MotoTrackOffer = 'motorcycle_track',
  DrivingSchoolSaleOffer = 'sale',
  DrivingSimulatorOffer = 'simulator',
  EquipmentOffer = 'equipment',
  DrivingSchoolVehiclesOffer = 'car',
}
